import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { brashBandTtkSchema } from "../schemas";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const BrassBandTTK = () => {
  const { language, token, currency } = useUserAuth();
  const [ttkEditMode, setTtkEditMode] = useState(false);
  const { user } = useUserAuth();
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState({});
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = res.data.data;
      const details = data[0].details;
      // const details = rawDetails ? JSON.parse(rawDetails) : null;
      if (details) {
        setMerchant(details);
        // formik.setValues(details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  const formik = useFormik({
    initialValues: {
      bandmember: merchant?.bandmember || "",
      charges: Math.floor(merchant?.charges * currency.value) || "",
      workingSince: merchant?.workingSince || [],
      areaOfWork: merchant?.areaOfWork || [],
      serviceOffered: merchant?.serviceOffered || [],
    },
    enableReinitialize: true,
    validationSchema: brashBandTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: {
            ...values,
            charges: Math.floor(values.charges * currency.country_value),
          },
        };

        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 201) {
          toast.success("Things to know added successfully.");
          setMerchant(values);
          formik.setValues(values);
          setTtkEditMode(false);
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
          setTtkEditMode(false);
        } else {
          toast.info(res.data.message || "Request submitted.");
          setTtkEditMode(false);
        }
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while submitting the data.");
      }
    },
  });

  const workingSinceOption = checkboxData.workSinceOption;
  const areaOfWorking = checkboxData.areaOfWorking;
  const serviceOfferedoption = checkboxData.serviceOfferedband;
  const atplaceoption = checkboxData.setatplace;
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
         <ThinksToKnowStatus/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header  text-white text-center "
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5>
                  {" "}
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff " }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Working Since</th>
                            <th style={{ width: "25%" }}>Area of Services</th>
                            <th style={{ width: "25%" }}>
                              Number of Band-Member
                            </th>
                            <th style={{ width: "25%" }}>
                              Starting Price (Wedding Band)
                            </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant?.workingSince?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>

                            <td>
                              {merchant.areaOfWork?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>
                            <td> {merchant?.bandmember}</td>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.charges
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Services Offered</th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.serviceOffered?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn text-white mb-2"
                    style={{ backgroundColor: "#085f9a" }}
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${
                    merchant ? "Make Changes" : "Tell me more about yourself"
                  }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Working Since <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workingSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                          formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Area of Services</label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={areaOfWorking}
                            selected
                            value={formik.values.areaOfWork}
                            onChange={(areaOfWork) =>
                              formik.setFieldValue("areaOfWork", areaOfWork)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.areaOfWork &&
                          formik.errors.areaOfWork ? (
                            <div className="text-danger">
                              {formik.errors.areaOfWork}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Number Of Band-Member</label>
                          <input
                            type="number"
                            placeholder="Number Of Band-member"
                            className="form-control"
                            name="bandmember"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.bandmember}
                          />
                          {formik.touched.bandmember &&
                          formik.errors.bandmember ? (
                            <div className="text-danger">
                              {formik.errors.bandmember}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Starting Price (Wedding Band)</label>
                          <input
                            type="number"
                            placeholder="Starting Price (Wedding Band)"
                            className="form-control"
                            name="charges"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.charges}
                          />
                          {formik.touched.charges && formik.errors.charges ? (
                            <div className="text-danger">
                              {formik.errors.charges}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Services Offered</label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={serviceOfferedoption}
                            selected
                            value={formik.values.serviceOffered}
                            onChange={(serviceOffered) =>
                              formik.setFieldValue(
                                "serviceOffered",
                                serviceOffered
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.serviceOffered &&
                          formik.errors.serviceOffered ? (
                            <div className="text-danger">
                              {formik.errors.serviceOffered}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn text-white"
                        type="submit"
                        style={{ backgroundColor: "#085f9a" }}
                      >
                        submit
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BrassBandTTK;
